import anime from 'animejs';

export default class Calendar {
  constructor(el) {
    this.isOpen = false;
    this.el = el;
    this.container = document.querySelector('#filteredList');

    this.bind();
  }

  bind() {
    this.el && this.container.addEventListener('click', this.toggle.bind(this));
  }

  toggle(e) {
    this.calendar = document.querySelector('.u-article-calendar');
    this.el = document.querySelector('[data-article-calendar]');

    // Close container when clicked on a date
    if (e.target.parentNode.classList.contains('Day')) {
      this.close();

      return;
    } else if (!this.el.contains(e.target)) {
      return;
    }

    this.isOpen ? this.close() : this.open();
  }

  open() {
    this.calendar.style.display = 'block';

    anime({
      targets: this.calendar,
      opacity: 1,
      easing: 'easeOutQuad',
      duration: 350,
      complete: () => {
        this.isOpen = true;
      },
    });
  }

  close() {
    this.isOpen = false;

    anime({
      targets: this.calendar,
      opacity: 0,
      easing: 'easeOutQuad',
      duration: 350,
      complete: () => {
        this.calendar.style.display = 'none';
      },
    });
  }
}
